export default {
  title: 'Package Unit Management',

  // Search filter area
  search: {
    keyword: 'Keyword Search',
    keywordPlaceholder: 'Package code, package name',
    status: 'Status',
    statusPlaceholder: 'Select status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    searchButton: 'Search',
    resetButton: 'Reset',
    searchPlaceholder: 'Search package unit name, code'
  },

  // Action buttons
  actions: {
    addPackageUnit: 'Add Package Unit',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    enableItem: 'Enable',
    disableItem: 'Disable',
    ediCodeSetting: 'EDI Code Setting',
    recordsCount: 'Total {count} records'
  },

  // Table columns
  table: {
    packageCode: 'Package Code',
    packageNameCn: 'Package Name (Chinese)',
    packageNameEn: 'Package Name (English)',
    status: 'Status',
    operation: 'Operation',
    code2Digit: 'Package Code (2-digit)',
    code4Digit: 'Package Code (4-digit)',
    nameCn: 'Package Name (Chinese)',
    nameEn: 'Package Name (English)',
    ediCode: 'EDI Code',
    codeCount: '{count} codes',
    notSet: 'Not Set',
    tableTitle2Digit: 'Package Code (2-digit)',
    tableTitle4Digit: 'Package Code (4-digit)',
    tableTitleNameCn: 'Package Name (Chinese)',
    tableTitleNameEn: 'Package Name (English)'
  },

  // Association modal
  modal: {
    title: 'Associate Package Unit',
    confirmText: 'Confirm Add ({count})',
    selected: 'Selected {count} package units, {total} available',
    selectedStatus: 'Selected {count} package units, {total} available',
    keyword: 'Keyword Search',
    searchPlaceholder: 'Package code, package name, 2-digit code, 4-digit code',
    status: 'Status',
    statusPlaceholder: 'Select status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    searchButton: 'Search',
    resetButton: 'Reset',
    // Add package unit modal
    addTitle: 'Add Package Unit',
    addConfirmText: 'Confirm Add',
    selectedCount: 'Selected {count} package units',
    tableTitle2Digit: 'Package Code (2-digit)',
    tableTitle4Digit: 'Package Code (4-digit)',
    tableTitleNameCn: 'Package Name (Chinese)',
    tableTitleNameEn: 'Package Name (English)'
  },

  // Confirmation dialogs
  confirm: {
    enableItem: 'Are you sure to enable this package unit?',
    disableItem: 'Are you sure to disable this package unit?',
    batchEnable: 'Are you sure to enable the selected {count} package units?',
    batchDisable: 'Are you sure to disable the selected {count} package units?',
    toggleStatus: 'Are you sure to {action} this package unit?'
  },

  // Form validation
  validation: {
    selectItems: 'Please select package units to associate'
  },

  // Message prompts
  messages: {
    selectToEnable: 'Please select package units to enable',
    selectToDisable: 'Please select package units to disable',
    selectToAssociate: 'Please select package units to add',
    loadError: 'Data loading failed',
    platformLoadError: 'Platform data loading failed',
    associateError: 'Add failed',
    associateSuccess: 'Added {count} package units',
    statusToggleError: 'Operation failed',
    statusToggleSuccess: 'Status toggle successful',
    batchEnableError: 'Batch operation failed',
    batchEnableSuccess: 'Enabled {count} package units',
    batchDisableError: 'Batch operation failed',
    batchDisableSuccess: 'Disabled {count} package units',
    ediCodeSaveSuccess: 'EDI code setting successful',
    ediCodeSaveError: 'EDI code saving failed'
  },

  // Status text
  statusText: {
    enabled: 'enabled',
    disabled: 'disabled'
  },

  // EDI setting modal
  ediModal: {
    title: 'EDI Code Setting',
    ediCodeList: 'EDI Code List',
    platform: 'Platform',
    platformRequired: 'Please select platform',
    platformPlaceholder: 'Select platform',
    ediCode: 'EDI Code',
    ediCodeRequired: 'Please enter EDI code',
    ediCodePlaceholder: 'Please enter EDI code',
    addEdiCode: 'Add EDI Code',
    deleteEdiCode: 'Delete',
    duplicateWarning: 'Duplicate platform',
    optional: '(Optional)',
    carrier: 'Carrier',
    carrierPlaceholder: 'Select carrier',
    duplicateRowsError: 'Duplicate platform in row(s) {rows}',
    duplicateRowsSaveError: 'Duplicate platform in row(s) {rows}, please fix before saving'
  }
}